import authCheckApp from './authCheckApp'

/**
 * 唤起手机扫描二维码
 * @since 1.0.0
 * @returns {Promise} 返回扫描二维码获取到的信息
 * @example
 * 
 * scanQRcode().then(res => {}).catch(err => {})
 */
function scanQRcode() {
    return new Promise((reslove, reject) => {
        authCheckApp()
            .then(() => {
            // 发起请求
                window.WebViewJavascriptBridge.callHandler('scanQRcode', null, (response) => {
                    if (typeof response === 'string') {
                        response = JSON.parse(response)
                    }
                    if (response.status === 0) {
                        reslove(response)
                    } else {
                        reject(response)
                    }
                })
            }).catch(err => {
                reject(err)
            })
    })
}

export default scanQRcode